import React from "react";
import IMAGES from "../../assets/images/images";
import HomeFoooter from "./components/HomeFooter";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

export default function Home() {
  let navigate = useNavigate();

  function handleClick() {
    navigate("/services");
  }
  return (
    <>
      {/* home parent div  container */}
      <motion.div className="w-full rounded-b-lg bg-primary-irisBlue py-2  sm:w-auto md:relative">
        {/* home child div container */}
        <div className="static flex w-full justify-end md:px-2 md:py-4">
          {/* h1  div container */}
          <div className=" mx-1  w-1/2 px-2 md:absolute md:left-5 md:top-5 md:w-1/3">
            <h1 className="text-center font-spartan text-3xl text-white hover:text-primary-lightCyan md:text-6xl">
              Are you tired of cleaning then it's time to call us
            </h1>
          </div>
          {/* image div container */}
          <div className="my-4 w-2/3 p-6  sm:h-96  md:w-auto ">
            <img
              className=" h-full w-full rounded-xl transition duration-700 ease-in-out hover:-translate-y-1
              hover:drop-shadow-2xl md:h-96 "
              src={IMAGES.img1}
              alt=""
            />
          </div>
        </div>
        {/* button div container */}
        <div className="md:rel:-translate-y-1ative mx-6 my-6 md:bottom-32 md:right-72 md:mx-96 md:px-4 md:py-4 ">
          <button
            onClick={handleClick}
            className=" block h-full w-full rounded-xl bg-primary-blue text-center font-dmMono text-2xl text-primary-lightCyan transition duration-700 ease-in-out hover:bg-primary-venderMint hover:font-spartan hover:text-black hover:shadow-2xl md:text-4xl"
          >
            Book Now
          </button>
        </div>
      </motion.div>
      <HomeFoooter />
    </>
  );
}
